import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/recollects',
  title: 'Recoletas',
  endpoint: '/app/purchase/request_recollect',
  breadcrumbs: [],
}
